import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from './ComponentsUI';
import { translate } from '../../utils/util';

const ConfirmButtonsUI = (props) => {
    const onConfirm = () => {
        if (props.onConfirm) {
            props.onConfirm();
        }
    };

    const onCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
    };

    return (
        <div className="row" style={{ paddingTop: '10px' }}>
            {
                props.onCancel && <div className="col s6">
                    <Button full="true" onClick={() => onCancel()} text={translate('cancel', 'general')} secundary="true" />
                </div>
            }
            {
                props.onConfirm && <div className="col s6">
                    <Button full="true" onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                </div>
            }
        </div>
    );
};

export default (withTranslation()(ConfirmButtonsUI));
